import {BaseSelect, BaseSelectProps} from "../../base-select";
import {useTranslation} from "react-i18next";

export type BaseTicketMappingIdSelectProps = BaseSelectProps

export const BaseTicketMappingIdSelect = (props: BaseTicketMappingIdSelectProps) => {
  const {t} = useTranslation("common");

  const {
    searchable = true,
    nothingFound = t('common.state.noresults', 'No Results'),
    ...rest
  } = props;

  return <BaseSelect {...rest} searchable={searchable} nothingFound={nothingFound}/>;
};
